/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};

(function () {
  'use strict';

  /**
   * Модель для товара в претензиях по товарам.
   */
  app.ClaimItem = app.Model.extend({
    defaults: {
      claim_item_reason_id: 1,
      claim_item_reason_title: app.helpers.TemplateHelper.getTemplate('#reason-title-default-template')(),
      received_qty: 1,
      ordered_qty: 1,
      qty: 1,
      claim_item_status_id: 1,
      valid: false
    },
    expand: 'expand=photos,item',
    parse: function (response) {
      if(response && response.claim_item_response) {
        response.claim_item_response = new app.ClaimItemResponses(_.toArray(response.claim_item_response));
      }
      return response;
    }
  });
})();

}.call(window));